import React from "react";
import { PageHero } from "@/components/SectionHeader";
import { QuoteForm } from "@/components/QuoteForm";
import { CheckCircle2 } from "lucide-react";

const points = [
  "Technical data and grade recommendation",
  "Price indication based on volume & destination",
  "Lead-time, packaging, and INCOTERMS options",
  "Ongoing supply-contract discussion if needed",
];

export default function Quote() {
  return (
    <div data-testid="quote-page">
      <PageHero
        testid="quote-hero"
        eyebrow="Get a Quote"
        title="Tell us what you need."
        description="Share your application, monthly volume and delivery location — we'll come back with technical specs and a price indication."
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <aside className="lg:col-span-4 space-y-6">
          <div className="bg-slate-50 border border-slate-100 rounded-2xl p-6">
            <h3 className="font-display uppercase text-lg font-bold text-slate-900">
              What you'll get back
            </h3>
            <ul className="mt-4 space-y-3">
              {points.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 text-sm text-slate-700"
                >
                  <CheckCircle2
                    size={18}
                    className="text-indigo-600 shrink-0 mt-0.5"
                  />
                  {p}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-navy text-white rounded-2xl p-6 relative overflow-hidden">
            <div
              className="absolute -top-10 -right-10 w-32 h-32 rounded-full blur-2xl opacity-40"
              style={{
                background:
                  "radial-gradient(circle at 50% 50%, #ec4899, transparent 60%)",
              }}
            />
            <p className="text-xs uppercase tracking-[0.25em] text-indigo-300">
              Typical Response
            </p>
            <p className="font-display text-3xl uppercase font-bold mt-2">
              Within 1 business day
            </p>
            <p className="text-sm text-slate-300 mt-3 leading-relaxed">
              Urgent enquiries are routed directly to our sales lead.
            </p>
          </div>
        </aside>

        <div className="lg:col-span-8 bg-white border border-slate-100 rounded-2xl p-8 shadow-sm">
          <h2 className="font-display text-2xl sm:text-3xl uppercase font-bold text-slate-900">
            Request a Quote
          </h2>
          <p className="text-slate-600 mt-2">
            Fields marked with * are required.
          </p>
          <div className="mt-8">
            <QuoteForm />
          </div>
        </div>
      </section>
    </div>
  );
}
